var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "bv-example-row" },
    [
      _c("Header"),
      _vm._v(" "),
      _c(
        "b-row",
        [_c("b-col", { staticClass: "hr", attrs: { cols: "12" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "3" } },
            [_c("b-list-group", [_c("Menu")], 1)],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "9" } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "head", attrs: { cols: "12" } },
                            [_c("h4", [_vm._v(":: Usuarios")])]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "breadcrumb",
                              attrs: { cols: "12" }
                            },
                            [
                              _c("b-link", { attrs: { href: "/users-list" } }, [
                                _vm._v("Lista de usuarios")
                              ]),
                              _vm._v(
                                " » " +
                                  _vm._s(_vm.user.first_name) +
                                  " " +
                                  _vm._s(_vm.user.last_name) +
                                  ":\n                "
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-2" }),
                      _vm._v(" "),
                      _c(
                        "b-form",
                        { staticClass: "mb-4", on: { submit: _vm.onSubmit } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "f_first_name",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "Nombres"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "first_name", state: _vm.state },
                                model: {
                                  value: _vm.user.first_name,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.user,
                                      "first_name",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "user.first_name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "f_last_name",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "Apellidos"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "last_name", state: _vm.state },
                                model: {
                                  value: _vm.user.last_name,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.user,
                                      "last_name",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "user.last_name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "f_email",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "Correo electrónico"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "email", state: _vm.state },
                                model: {
                                  value: _vm.user.email,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.user,
                                      "email",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "user.email"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "f_role",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "Tipo"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "role", state: _vm.state },
                                model: {
                                  value: _vm.user.role,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.user,
                                      "role",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "user.role"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "f_brand",
                                horizontal: "",
                                "label-cols": 4,
                                breakpoint: "md",
                                label: "Marca"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "brand", state: _vm.state },
                                model: {
                                  value: _vm.user.brand,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.user,
                                      "brand",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "user.brand"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: {
                                type: "submit",
                                variant: "primary derco"
                              }
                            },
                            [_vm._v("Actualizar")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a15352b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a15352b6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditUser.vue
// module id = null
// module chunks = 